import { render, staticRenderFns } from "./SitemapSection.vue?vue&type=template&id=797a0fbe&scoped=true&"
import script from "./SitemapSection.vue?vue&type=script&lang=js&"
export * from "./SitemapSection.vue?vue&type=script&lang=js&"
import style0 from "./SitemapSection.vue?vue&type=style&index=0&id=797a0fbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797a0fbe",
  null
  
)

export default component.exports